<template>
  <div class="side-block">
    <div class="block-title">热门话题</div>
    <div class="title-line"></div>
    <div class="list">
      <div class="item" v-for="(item, key) in hotTopicList" :key="item.topicId">
        <div class="sort" :class="'sort-' + key">{{ key + 1 }}</div>
        <div class="title">
          <router-link
            :to="{ path: '/view/topic', query: { id: item.topicId } }"
            target="_blank"
            >{{ item.topicName }}</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import Http from "../until/http";
export default defineComponent({
  setup() {
    let hotTopicList = ref([]);

    onMounted(() => {
      Http.getHotTopic({ pageNow: 1 }).then((res) => {
        if (res.hotTopicList) {
          hotTopicList.value = res.hotTopicList;
        }
      });
    });

    return {
      hotTopicList,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "../scss/_variables.scss";
.side-block {
  margin-bottom: 12px;
  padding: 5px 0;
  background: #fff;
  margin-bottom: 12px;
  .block-title {
    line-height: 55px;
    font-size: 16px;
  }
  .title-line {
    height: 0.5px;
    background: #e8e8e8;
    margin-top: -2px;
    margin-left: -15px;
    width: 308px;
  }
  .list {
    padding: 11px 0px;
    .item {
      height: 40px;
      line-height: 40px;
      a {
        color: #333;
      }
      a:hover {
        color: $primary-color;
      }
      .sort {
        width: 30px;
        float: left;
        text-align: center;
        font-weight: bold;
        font-size: 15px;
        color: #9195a3;
      }
      .sort-0 {
        color: #ea444d;
      }
      .sort-1 {
        color: #ed6f2d;
      }
      .sort-2 {
        color: #efae46;
      }
      .title {
        margin-left: 30px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
}
</style>